import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M7.5 3.5a2.5 2.5 0 0 0-.78.125A3.5 3.5 0 1 0 3.5 8.5h4a2.5 2.5 0 0 0 0-5"
    }, null, -1)
  ]));
}
const programmingCloud = { render };
export {
  programmingCloud as default,
  render
};
//# sourceMappingURL=programming-cloud.svg.js.map
